/** Service principal de la consultoría (JSON-LD en home) */
export const HOME_SERVICE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Software de gestión e IA para pymes y ONG en Tenerife',
  description:
    'Software de gestión e inteligencia artificial para pymes y ONG en Tenerife. Si hace falta un ERP, implantamos Vulpin Suite, Dynamics 365 Business Central u Odoo, o integramos el que ya está. En el mismo encargo: ciberseguridad y la IA en producción.',
  url: 'https://e-asy.es/',
  serviceType: 'Software de gestión',
  provider: {
    '@type': 'Organization',
    name: 'E-ASY',
    url: 'https://e-asy.es',
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Canarias' },
    { '@type': 'Country', name: 'España' },
  ],
};
